<!--
 * @Author: DY
 * @Date: 2020-06-20 14:57:00
 * @LastEditTime: 2025-02-21 17:10:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ShiMo_Mobile\src\components\previewPage\FormView.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="form-view">
            <van-nav-bar
                title="表单预览"
                left-text="返回"
                left-arrow
                v-if="isNews != true"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <iframe :src="src" frameborder="0"></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 表单缩放
    name: 'form-view',
    components: {},
    props: {},
    data() {
        return {
            token: '',
            // 合同审批页面传入token
            newsToken: '',
            src: '',
            // 表单参数
            formData: {},
            // 审批数据
            approvalData: {},
            // 是否是消息跳转审批
            isNews: false,

        };
    },
    computed: {},
    watch: {},
    created() {
        this.isNews = this.$route.params.isNews;
        this.formData = this.$route.params.formData;
        this.newsToken = this.$route.params.thisToken;
        this.approvalData = this.$route.params.approvalData;
        if ((this.newsToken || '') !== '') {
            this.token = this.newsToken;
        } else {
            this.token = window.localStorage.getItem('token');
        }
        let AppFormUrl = '';
        if (this.formData.AppFormUrl) {
            AppFormUrl = this.formData.AppFormUrl.includes('FormCode') ? this.formData.AppFormUrl : `FormCode=${this.formData.AppFormUrl}`;
        } else if (this.formData.FormUrl) {
            AppFormUrl = this.formData.FormUrl.includes('FormCode') ? this.formData.FormUrl : `FormCode=${this.formData.FormUrl}`;
        }
        this.src = `${this.GLOBAL.FORM_BASE_URL}angularForm/FormView.html?${AppFormUrl}&`;
        this.src += `frameId=${this.formData.FormId}&`;
        this.src += 'FormUseInJiYunFlow=true&';
        if (this.formData.FormKeyValue) {
            this.src += `PKValues=${this.formData.FormKeyValue}&`;
        }
        this.src += 'IsView=true&';
        this.src += `businessInstanceId=${this.approvalData.BusinessInstanceId}&`;
        this.src += 'DeviceType=2&';
        this.src += `token=${this.token}`;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus" scoped>
.form-view
    height 100%
    display: flex
    flex-direction: column;
    section
        flex: 1
        height: 0
        overflow hidden
        iframe
            width 100%
            height 100%
</style>


